export type ComboboxOption = {
  value: string
  label: string
}

export type ComboboxPreviewState =
  | 'default'
  | 'focused'
  | 'filled'
  | 'disabled'
  | 'error'
  | 'expanded'
  | 'with-tooltip'
  | 'optional'
  | 'with-info'

export const COMBOBOX_PREVIEW_STATES: ComboboxPreviewState[] = [
  'default',
  'focused',
  'filled',
  'disabled',
  'error',
  'expanded',
  'with-tooltip',
  'optional',
  'with-info',
]

export const COMBOBOX_PREVIEW_STATE_LABELS: Record<
  ComboboxPreviewState,
  string
> = {
  default: 'Default',
  focused: 'Focused',
  filled: 'Filled',
  disabled: 'Disabled',
  error: 'Error',
  expanded: 'Expanded',
  'with-tooltip': 'With tooltip',
  optional: 'Optional',
  'with-info': 'With info',
}

export const COMBOBOX_DEMO_LABEL = 'Chart name'

export const COMBOBOX_DEMO_PLACEHOLDER = 'Type or select'

export const COMBOBOX_DEMO_OPTIONS: ComboboxOption[] = [
  {
    value: 'Comprehensive Oral Exam (COE)',
    label: 'Comprehensive Oral Exam (COE)',
  },
  {
    value: 'Periodic Oral Exam (POE)',
    label: 'Periodic Oral Exam (POE)',
  },
  { value: 'Limited Exam', label: 'Limited Exam' },
  { value: 'Consultation', label: 'Consultation' },
]

export const COMBOBOX_DEMO_FILLED_VALUE = 'Periodic Oral Exam (POE)'

export const COMBOBOX_DEMO_ERROR_MESSAGE = 'Error description'

export const COMBOBOX_DEMO_INFO_MESSAGE = 'Info text'

export type ComboboxProps = {
  label?: string
  placeholder?: string
  options?: ComboboxOption[]
  value?: string
  defaultValue?: string
  /** Allow values that are not in the options list. Defaults to true. */
  allowCustom?: boolean
  /** Filter options as the user types. Defaults to true. */
  filterable?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  optional?: boolean
  showTooltip?: boolean
  className?: string
  /** dark-mode palette. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: ComboboxPreviewState
  onChange?: (value: string) => void
}
